import React, { useState, useContext, useEffect } from "react";
import DynamicIcon from "../dynamicicon";
import JisInput from "../controls/jisInput";
import JisDropdown from "../controls/jisDropdown";

import JisButton from "../controls/jisButton";
import { ShareContext } from "../../context/ShareContext";

export default function CaseSearch({
  source = "empty",
  onSearch,
  frequentData,
  filingtype = "all",
  caseprocess = "all",
}) {
  const { profile, token } = useContext(ShareContext);
  const [search, setSearch] = useState({ caseprocess, filingtype });
  const [initFilingtype, setInitFilingType] = useState("");
  const [startType, setStartType] = useState("text");
  const [endType, setEndType] = useState("text");

  const onSearchChange = (e) => {
    setSearch({ ...search, [e.target.name]: e.target.value });
  };
  const onClickSearch = () => {
    onSearch(search);
  };

  useEffect(() => {
    setSearch({ ...search, caseprocess, filingtype });
  }, [caseprocess]);

  const onFilingType = (v) => {
    setSearch({ ...search, filingtype: v });
  };
  const onCaseProcess = (v) => {
    setSearch({ ...search, caseprocess: v });
  };
  useEffect(() => {
    if (filingtype == "all") {
      if (profile.role.filingTypeId == null || profile.role.filingTypeId == 0) {
        setInitFilingType("all");
        onFilingType("all");
      } else if (profile.role.filingTypeId == 1) {
        setInitFilingType("litigation");
        onFilingType("litigation");
      } else if (profile.role.filingTypeId == 2) {
        setInitFilingType("adr");
        onFilingType("adr");
      }
    } else {
      setInitFilingType(filingtype);
      onFilingType(filingtype);
    }
  }, [profile]);
  useEffect(() => {
    onSearch(search);
  }, [search.filingtype, search.caseprocess]);

  return (
    <div className="panel">
      <div className="title">Case Search</div>
      <div className="panel-body">
        <form>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2 }}>
                  <div className="input-group">
                    <div className="input-wrapper">
                      <DynamicIcon iname="users" />
                      <input
                        placeholder="Search Case Title or Parties name"
                        name="caseTitle"
                        value={search.caseTitle}
                        onChange={onSearchChange}
                      />
                    </div>
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div className="input-group">
                    <div className="input-wrapper">
                      <DynamicIcon iname="signature" />
                      <input
                        placeholder="Search Suit Number e.g ID/ADR/0427/2025"
                        value={search.caseNumber}
                        onChange={onSearchChange}
                        name="caseNumber"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex" }}>
                <div className="select-group">
                  {/*  <label> Case Type  </label> */}
                  <select
                    name="caseTypeId"
                    value={search.caseTypeId}
                    required={true}
                    onChange={onSearchChange}
                  >
                    <option value="">All Case type</option>
                    {frequentData?.casetype?.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                        {opt.caseType1}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="select-group">
                  <select
                    name="caseCategoryId"
                    value={search.caseCategoryId}
                    required={true}
                    onChange={onSearchChange}
                  >
                    <option value="">All Classification</option>
                    {frequentData?.casecategories
                      .filter((c) => c.caseTypeId == search.caseTypeId)
                      .map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.categoryTitle}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="input-group">
                  <div className="input-wrapper">
                    <DynamicIcon iname="calendar-days" />
                    <input
                      placeholder="From Date e.g 4/4/2025"
                      type={startType}
                      onFocus={() => setStartType("date")}
                      onBlur={(e) => {
                        if (!e.target.value) setStartType("text");
                      }}
                      value={search.fromDate}
                      onChange={onSearchChange}
                      name="fromDate"
                    />
                  </div>
                </div>
                <div className="input-group">
                  <div className="input-wrapper">
                    <DynamicIcon iname="calendar-days" />
                    <input
                      placeholder="To Date eg 30/4/2025"
                      type={endType}
                      onFocus={() => setEndType("date")}
                      onBlur={(e) => {
                        if (!e.target.value) setEndType("text");
                      }}
                      value={search.toDate}
                      onChange={onSearchChange}
                      name="toDate"
                    />
                  </div>
                </div>
              </div>

              <div style={{ textAlign: "center" }}>
                <JisButton onClick={onClickSearch}>Search</JisButton>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="button-group">
          {initFilingtype == "all" && (
            <div
              className={`choice  ${
                search.filingtype == "all" ? "active" : ""
              }`}
              onClick={() => onFilingType("all")}
            >
              All
            </div>
          )}

          {(initFilingtype == "all" || initFilingtype == "litigation") && (
            <div
              className={`choice  ${
                search.filingtype == "litigation" ? "active" : ""
              }`}
              onClick={() => onFilingType("litigation")}
            >
              Litigation Only
            </div>
          )}

          {(initFilingtype == "all" || initFilingtype == "adr") && (
            <div
              className={`choice  ${
                search.filingtype == "adr" ? "active" : ""
              }`}
              onClick={() => onFilingType("adr")}
            >
              ADR Only
            </div>
          )}
        </div>
        <div className="button-group">
          {caseprocess == "all" && (
            <div
              className={`choice  ${
                search.caseprocess == "all" ? "active" : ""
              }`}
              onClick={() => onCaseProcess("all")}
            >
              All
            </div>
          )}

          {(caseprocess == "all" || caseprocess == "Normal") && (
            <div
              className={`choice  ${
                search.caseprocess == "Normal" ? "active" : ""
              }`}
              onClick={() => onCaseProcess("Normal")}
            >
              Normal
            </div>
          )}

          {(caseprocess == "all" || caseprocess == "Urgent") && (
            <div
              className={`choice  ${
                search.caseprocess == "Urgency" ? "active" : ""
              }`}
              onClick={() => onCaseProcess("Urgency")}
            >
              Urgency
            </div>
          )}

          {(caseprocess == "all" || caseprocess == "Fast Track") && (
            <div
              className={`choice  ${
                search.caseprocess == "Fast Track" ? "active" : ""
              }`}
              onClick={() => onCaseProcess("Fast Track")}
            >
              Fast Track
            </div>
          )}

          {(caseprocess == "all" || caseprocess == "Vacation") && (
            <div
              className={`choice  ${
                search.caseprocess == "Vacation" ? "active" : ""
              }`}
              onClick={() => onCaseProcess("Vacation")}
            >
              Vacation
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
